import React, { useState } from 'react'
import { TbChevronDown, TbChevronRight } from 'react-icons/tb'
import AllFilter from './AllFilter'

const ShopHero = () => {
    const [active, setActive] = useState("all")
    const [priceRange, setPriceRange] = useState(1000)

    const filters = [
        {
            title: "All",
            active: "all"
        },
        {
            title: "SHA256/Bitcoin Miners",
            active: "bitcoin"
        },
        {
            title: "Iceriver",
            active: "iceriver"
        },
        {
            title: "Bitmain",
            active: "bitmain"
        },
    ]



    const handleActive = (index) => {
        setActive(index)
    }
    const handleRangeChange = (event) => {
        setPriceRange(event.target.value)
    }
    
    // console.log(priceRange)

    const activeIndex = filters.findIndex(item => item.active === active);
    const dat = [
        { product: <AllFilter /> },
        { product: "All Products2" },
        { product: "All Products3" },
        { product: "All Products4" }
    ]
    
    return (
        <div className='flex flex-col mt-6 z-[400]'>
            <div className='absolute lg:block hidden w-[400px] h-[400px] left-[-100px] top-[-200px] bg-blue-400 bg-opacity-30 rounded-full blur-2xl'></div>
            <div className='flex lg:flex-row flex-col py-[5%] w-full gap-5 justify-between z-[500]'>
                <div className='lg:w-[20%] w-full'>
                    <div className='w-full border border-white border-opacity-75 rounded-lg'>
                        <p className='lg:text-[25px] p-2  text-[15px] font-semibold text-white'>Filters</p>
                        <div className='flex flex-col'>
                            <div className='flex p-4 bg-[#4E9AE1]'>
                                <span className=' flex w-full justify-between items-center'>
                                    <p className='text-white font-semibold bg-[]'>Categories</p>
                                    <TbChevronDown className='text-black' />
                                </span>
                            </div>
                            <div className='flex p-4 flex-col gap-2'>
                                <p className='text-[#2366CF] lg:text-[17px] text-[12px]'>SHA256/Bitcoin Miners</p>
                                <p className='text-white text-opacity-70'>Iceriver</p>
                                <p className='text-white text-opacity-70'>Bitmain</p>
                            </div>

                        </div>
                        <div className='flex flex-col'>
                            <div className='flex p-4 bg-[#4E9AE1]'>
                                <span className=' flex w-full justify-between items-center'>
                                    <p className='text-white font-semibold bg-[]'>Price Range</p>
                                    <TbChevronDown className='text-black' />
                                </span>
                            </div>
                            <div className='flex p-4 flex-col items-center gap-2'>
                                <div className='w-full'>
                                    <div class="relative mb-6">
                                        <label for="labels-range-input" class="sr-only">Labels range</label>
                                        <input id="labels-range-input"
                                            type="range" 
                                            value={priceRange}
                                            min="0"
                                            max="3200"
                                            onChange={handleRangeChange}
                                            class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700" />
                                        <span class="text-xs text-gray-500 dark:text-gray-400 absolute start-0 -bottom-6">($0)</span>
                                        <span class="text-xs text-gray-500 dark:text-gray-400 absolute start-1/3 -translate-x-1/2 rtl:translate-x-1/2 -bottom-6">$1000</span>
                                        <span class="text-xs text-gray-500 dark:text-gray-400 absolute start-2/3 -translate-x-1/2 rtl:translate-x-1/2 -bottom-6">$2000</span>
                                        <span class="text-xs text-gray-500 dark:text-gray-400 absolute end-0 -bottom-6">($3200)</span>
                                    </div>
                                </div>

                                <p className='text-white text-opacity-70'>Price: $0.00 – $3200.00</p>
                            </div>
                        </div>
                        <div className='flex flex-col'>
                            <div className='flex p-4 bg-[#4E9AE1]'>
                                <span className=' flex w-full justify-between items-center'>
                                    <p className='text-white font-semibold bg-[]'>Brands</p>
                                    <TbChevronDown className='text-black' />
                                </span>
                            </div>
                            <div className='flex p-4 flex-col gap-2'>
                                <div className='flex flex-row items-center gap-3'>
                                    <input type="checkbox" name="" id="" />
                                    <p className='text-white text-opacity-70 lg:text-[17px] text-[12px]'>Canaan Avalon</p>
                                </div>
                                <div className='flex flex-row items-center gap-3'>
                                    <input type="checkbox" name="" id="" />
                                    <p className='text-white text-opacity-70 lg:text-[17px] text-[12px]'>Bitmain</p>
                                </div>
                            </div>

                        </div>
                        <div className='flex flex-col'>
                            <div className='flex p-4 bg-[#4E9AE1]'>
                                <span className=' flex w-full justify-between items-center'>
                                    <p className='text-white font-semibold bg-[]'>Discount</p>
                                    <TbChevronDown className='text-black' />
                                </span>
                            </div>
                            <div className='flex p-4 flex-col gap-2'>
                                <div className='flex flex-row items-center gap-3'>
                                    <input type="checkbox" name="" id="" />
                                    <p className='text-white text-opacity-70 lg:text-[17px] text-[12px]'>Yes</p>
                                </div>
                                <div className='flex flex-row items-center gap-3'>
                                    <input type="checkbox" name="" id="" />
                                    <p className='text-white text-opacity-70 lg:text-[17px] text-[12px]'>No</p>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
                <div className='lg:w-[75%] w-full'>
                    <div className='flex items-center text-white text-opacity-60 gap-3 p-4 border border-white border-opacity-60 w-full rounded-lg'>
                        <p>Home</p>
                        <TbChevronRight />
                        <p>Shop</p>
                    </div>

                    <div className='flex flex-row w-full justify-between items-center py-8 text-white text-opacity-40'>
                        <p>Related To:</p>
                        <div className='lg:w-[80%] w-full flex flex-row justify-between'>
                            <div className='w-fit grid grid-cols-4'>
                                {
                                    filters.map((i, d) => (
                                        <div key={d}>
                                            <p onClick={() => handleActive(i.active)} key={d} className={`w-full items-center cursor-pointer p-3 ${active === i.active ? "bg-[#4E9AE1] max-w-fit rounded-lg" : ""}`}>{i.title}</p>
                                        </div>
                                    ))
                                }
                            </div>

                        </div>
                        <input placeholder='12' className='w-[80px] border-[1px] text-white bg-transparent outline-none p-2 rounded-lg' type="number" name="" id="" />
                    </div>
                    <div className='flex text-white w-full'>
                        {dat[activeIndex].product}
                    </div>
                </div>
            </div>

        </div>
    )
}

export default ShopHero